import { Box } from "@mui/system";
import ReactPlayer from "react-player";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Typography, IconButton } from "@mui/material";

const WalkThroughContent = ({
  item,
  handleWalkThroughDrawer,
  showOrHideCheckBox,
  showOrHideAssessmentWalkthrough,
}) => {
  return (
    <div className="FSUnmask">
      <Box
        sx={{
          padding: "10px",
          backgroundColor: "white",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <IconButton
          aria-label="close"
          onClick={() => handleWalkThroughDrawer(null)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "black",
            marginY: "10px",
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          height: "90%",
          display: "flex",
          backgroundColor: "white",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            padding: "20px",
            backgroundColor: "white",
            textAlign: "left",
          }}
        >
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "bold",
              mb: "15px",
            }}
          >
            {item.name}
          </Typography>

          <ul
            className="FSUnmask"
            style={{
              marginTop: 0,
              marginBottom: 0,
              padding: "0px",
              paddingRight: "0px",
              color: "#00000099",
              fontSize: "14px",
            }}
          >
            {item.walkthrough.map((elem) => {
              return (
                <div style={{ marginBottom: "15px" }}>
                  <li style={{ marginLeft: "20px" }}>
                    {elem.text}
                    {elem.point &&
                      elem.point.map((lineItem) => {
                        return <p style={{ margin: "0px" }}>{lineItem}</p>;
                      })}
                  </li>
                  {elem.url && (
                    <Box sx={{ marginY: "20px" }}>
                      <ReactPlayer
                        width="100%"
                        url={elem.url}
                        controls={true}
                        height="170px"
                      />
                      <Typography variant="p" fontSize={14}>
                        {"Patient images used with permission."}
                      </Typography>
                    </Box>
                  )}
                </div>
              );
            })}
          </ul>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography variant="p" fontSize={14}>
            Need more assistance?
          </Typography>
          <Button
            variant="text"
            sx={{ color: "#2196F3", textDecoration: "underline" }}
            onClick={() => {
              showOrHideCheckBox(false);
              showOrHideAssessmentWalkthrough(true);
            }}
          >
            Start Tutorial
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default WalkThroughContent;
